exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.spin-animation[data-v-53b9c09e] {\n  animation: spin-53b9c09e 3s linear infinite;\n}\n@keyframes spin-53b9c09e {\n0% {\n    transform: rotate(0deg);\n}\n100% {\n    transform: rotate(360deg);\n}\n}\n", ""]);

// exports
